export default __webpack_public_path__ + "static/media/190629_190332_Joe & Adam Sparring.65487ad4.jpg";